export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyAEniJLyO1D_Q9QUDCNU3LpPb0YBKI7u1c',
  authDomain: 'budgetfly-sales.firebaseapp.com',
  projectId: 'budgetfly-sales',
  storageBucket: 'budgetfly-sales.firebasestorage.app',
  messagingSenderId: '108221433421',
  appId: '1:108221433421:web:dd42dce6ca399b566c3e04',
  measurementId: 'G-4ETYQRTR1J',
}
